import { createContext, useContext, useState, useCallback } from 'react';

const ConsentContext = createContext(null);

const STORAGE_KEY = 'aitrack:consent';
export const CONSENT_VERSION = 1;

function loadConsent() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Versione diversa → riproponi il banner
    if (!parsed || parsed.v !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function ConsentProvider({ children }) {
  const [consent, setConsent] = useState(loadConsent);
  const [prefsOpen, setPrefsOpen] = useState(false);

  const persist = useCallback((choice) => {
    const full = {
      v: CONSENT_VERSION,
      necessary: true,
      analytics: !!choice.analytics,
      marketing: !!choice.marketing,
      ts: Date.now(),
    };
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(full));
    } catch { /* storage non disponibile: consenso valido solo per la sessione */ }
    setConsent(full);
    setPrefsOpen(false);
  }, []);

  const acceptAll = useCallback(() => persist({ analytics: true, marketing: true }), [persist]);
  const rejectAll = useCallback(() => persist({ analytics: false, marketing: false }), [persist]);
  const savePreferences = useCallback((choice) => persist(choice), [persist]);
  const openPreferences = useCallback(() => setPrefsOpen(true), []);
  const closePreferences = useCallback(() => setPrefsOpen(false), []);

  const value = {
    consent,
    hasChoice: !!consent,
    prefsOpen,
    acceptAll,
    rejectAll,
    savePreferences,
    openPreferences,
    closePreferences,
  };

  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
}

export function useConsent() {
  const ctx = useContext(ConsentContext);
  if (!ctx) throw new Error('useConsent must be used within ConsentProvider');
  return ctx;
}
